import type { UseQueryOptionsType } from './UseQueryOptionsType';
import type { AxiosError } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { KEYS, repository } from '@repositories/Repository';
import type IExchangeRateRepository from '@repositories/exchangeRateRepository/IExchangeRateRepository';
import type { ExchangeRateFilter } from '@repositories/exchangeRateRepository/exchangeRate.types';
import type { Page } from '@type/Page';
import { ExchangeRateModel } from '@repositories/exchangeRateRepository/models/ExchangeRateModel';

const exchangeRateRepo = repository.get<IExchangeRateRepository>(KEYS.EXCHANGE_RATE_REPOSITORY);
const exchangeRateQueryKey = {
  all: ['exchangeRateRequest'] as const,
  lists: () => [...exchangeRateQueryKey.all, 'list'] as const,

  list: (filter: ExchangeRateFilter) => [...exchangeRateQueryKey.lists(), filter] as const,
};

export const useGetExchangeRates = (
  queries?: ExchangeRateFilter,
  options?: UseQueryOptionsType<Page<ExchangeRateModel>>,
) =>
  useQuery<Page<ExchangeRateModel>, AxiosError>({
    queryKey: exchangeRateQueryKey.list(queries ? { ...queries } : {}),
    queryFn: async () => {
      const result = await exchangeRateRepo.getList(queries ?? {});
      return {
        ...result,
        content: result.content.map(dto => new ExchangeRateModel(dto)),
      };
    },
    ...options,
  });
